var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksArrowPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 35,
    height: 35,
    rx: 12,
    transform: "rotate(-180 35 35)",
    fill: "url(#paint0_linear_330_1674)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7531 11.2568L18 18.4324L25.2469 11.2568C25.4198 11.0856 25.6245 11 25.861 11C26.0976 11 26.3023 11.0856 26.4752 11.2568L28.7407 13.5C28.9136 13.6712 29 13.8739 29 14.1081C29 14.3423 28.9136 14.545 28.7407 14.7162L18.6141 24.7432C18.4413 24.9144 18.2366 25 18 25C17.7634 25 17.5587 24.9144 17.3859 24.7432L7.25931 14.7162C7.08644 14.545 7 14.3423 7 14.1081C7 13.8739 7.08644 13.6712 7.25931 13.5L9.52481 11.2568C9.69769 11.0856 9.9024 11 10.139 11C10.3755 11 10.5802 11.0856 10.7531 11.2568Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_1674",
    x1: 34.5285,
    y1: 71.2886,
    x2: 67.9736,
    y2: 35.5675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksArrowPointer);
export default __webpack_public_path__ + "static/media/howItWorks_arrow_pointer.cfc2f38b23d3bc8c5c8e522394725647.svg";
export { ForwardRef as ReactComponent };